import React from "react";
import HttpService from '../utils/Http.services';
import { siteConfig, siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import TLink from "../components/TLink";
// import RandomBack from "../components/RandomBack";
import StagesManager from "../components/StagesManager";
import LoginFirstStep from "./login/LoginFirstStep";
// import LoginCodeStep from "./login/LoginCodeStep";
// import LoginPasswordStep from "./login/LoginPasswordStep";
// import LoginInfoStep from "./login/LoginInfoStep";
// import LoginWelcomeStep from "./login/LoginWelcomeStep";
import { chooseWallpaper, getToken, pathMaker, translate } from "../utils/useful";
import Configurer from '../components/Configurer'

class LoginWithUsername extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // colors: ['d7e2f7', 'eee1ff', 'fedfe7', 'dad6e4', 'f7dbd7', 'fff2e1'],
      loginInfo: {},
      stage: 0,
      canResend: true,
      errors: [],
      data: {},
      phone: '',
      settings: { indicatorType: 'phone', mode: 'login', loginWithCode: false, passwordRequired: true }
    }
  }


  componentDidMount() {

    this.changeStage('init')
    if (this.props.user.loggedin) {
      // this.props.history.push(pathMaker('/profile'))
    } else {
      let settings = this.state.settings
      let pathname = this.props.location.pathname.split('/')
      pathname = pathname[pathname.length - 1]
      if (pathname.toLowerCase() === 'forgotpassword') {
        settings.mode = 'forgotPassword'
      }

    }
  }

  goToInitPage = () => {
    this.changeStage('init')
  }

  componentDidUpdate(prevProps) {
    if (this.props.user != prevProps.user) {
      setTimeout(() => {
        // this.checkLogin()
      }, 4000);
    }
  }


  checkLogin() {
    if (this.props.user.loggedin) {
      // this.setState({})
      if (getToken()) {
        this.props.history.push(pathMaker('/me'))
      }
    }

  }


  postUserIndicator = (cb) => {


    // this.loginDone({ user: { name: 'hasan', _id: '1234567' }, auth: { token: '12345689' } })

    // return


    let data = this.state.data

    console.log(data)
    // if (data.userIndicator && data.userIndicator.length >= 5) {

    HttpService.request("userLogin", data, (fetchResult, fetchError, fetchStatus) => {


      // if (fetchError ) { if (cb) { cb(null, fetchError.message) }; return }
      if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }


      //! if (fetchResult.token) {
      // !  fetchResult.auth = {token:fetchResult.token}

      // console.log(fetchResult)

      this.loginDone(fetchResult)
      // this.loginDone({ user: { name: 'hasan' } }, { auth: { token: '12345689' } })
      //! }

      // this.setData({ exist: fetchResult.exist })
      // if (fetchResult.exist && !this.state.settings.loginWithCode) {
      //   this.changeStage('password')
      // } else {
      //   this.changeStage('code')
      // }
      // if (cb) { cb() }
      //   })
      // } else {
      //   if (this.state.settings.indicatorType === 'phone') {
      //     cb(null, { userIndicator: "{{lang}}errors.phoneLength" })
      //   }
      //   if (this.state.settings.indicatorType === 'email') {
      //     cb(null, { userIndicator: "{{lang}}errors.emailPattern" })
    })
    // }
  }

  postForgotPassword = (cb) => {
    let data = this.state.data
    if (data.userIndicator && data.userIndicator.length >= 4) {
      HttpService.request("postForgotPassword", data, (fetchResult, fetchError) => {
        //  console.log(fetchResult)
        if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
        this.changeStage('code')
        if (cb) { cb() }
      })
    } else {
      if (this.state.settings.indicatorType === 'phone') {
        cb(null, { userIndicator: "{{lang}}errors.phoneLength" })
      }
      if (this.state.settings.indicatorType === 'email') {
        cb(null, { userIndicator: "{{lang}}errors.emailPattern" })
      }
    }
  }


  // postActicationCode = (cb) => {

  //   let data = this.state.data
  //   if (data.userIndicator && data.userIndicator.length >= 0 && data.code && String(data.code).length >= 4) {
  //     HttpService.request((this.state.data.exist || this.state.settings.mode === "forgotPassword") ? "signinActicationCode" : 'signupActicationCode', data, (fetchResult, fetchError) => {
  //       if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
  //       if (this.state.data.exist || this.state.settings.mode === "forgotPassword") {
  //         if (this.state.settings.passwordRequired || this.state.settings.mode === "forgotPassword") {
  //           this.changeStage('password')
  //         } else {
  //           // LOGIN
  //           this.loginDone(fetchResult)
  //         }
  //       } else {
  //         this.changeStage('info')
  //       }
  //       if (cb) { cb() }
  //     })
  //   } else {
  //     cb(null, { code: "{{lang}}errors.codeLength" })
  //   }
  // }


  // postPassword = (cb) => {

  //   let data = this.state.data
  //   if (data.userIndicator && data.userIndicator.length >= 0) {
  //     HttpService.request(this.state.settings.mode === 'forgotPassword' ? "postNewPassword" : 'postPassword', data, (fetchResult, fetchError) => {
  //       if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
  //       this.loginDone(fetchResult)
  //       if (cb) { cb() }
  //     })
  //   } else {
  //     cb(null, { code: "{{lang}}errors.codeLength" })
  //   }
  // }


  postUserInfo = (cb) => {
    let data = this.state.data
    if (data.userIndicator && data.userIndicator.length >= 0 && data.code && String(data.code).length >= 4) {
      HttpService.request("postUserInfo", data, (fetchResult, fetchError) => {
        if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
        this.loginDone(fetchResult)
        if (cb) { cb() }
      })
    } else {
      cb(null, { code: "{{lang}}errors.codeLength" })
    }
  }


  // loginDone = (data) => {
  //   this.setData(data.payload)
  //   if (data.payload?.access_token) {
  //     this.props.actions.setUser(data.payload, {token:data.payload.access_token}, true)
  //     // this.changeStage('welcome')
  //     this.props.history.push('/')
  //   }
  // }

  // loginDone = (data) => {
  //   this.setData(data.user)
  //   // console.log(data)
  //   if (data.auth?.token) {
  //     this.props.actions.setUser(data.user, data.auth, true)
  //     this.props.history.push('/')
  //     // this.changeStage('welcome')
  //   }
  // }

  loginDone = (data) => {
    this.setData(data.user)
    // console.log(data)
    if (data.auth?.token) {
      this.props.actions.setUser(data.user, data.auth, true)
      // window.history.pushState(null, null, '/');
      // console.log("DONE1")
      // this.props.history.push(pathMaker('/'))
      window.history.pushState(null, null, pathMaker('/'));

      // console.log("DONE2")

      // this.props.history.push('/')
      // this.changeStage('welcome')
    }
  }


  // loginDone = (data) => {
  //   // this.setData(data.user)
  //   this.setData(data.user)

  //   // console.log(data)
  //   if (data.auth?.token) {
  //     this.props.actions.setUser(data.user, data.auth, true)
  //     this.changeStage('welcome')
  //   }
  // }


  setData = (data, cb) => {
    let newData = this.state.data
    for (const [key, value] of Object.entries(data)) {
      newData[key] = value
    }
    this.setState({ data: newData }, () => {
      if (cb) { cb() }
    })
  }



  changeStage = (newStage, cb) => {
    if (this.stageManager) {
      this.stageManager.changeStage(newStage, cb)
    }
  }

  lastStage = () => {
    if (this.stageManager) {
      this.stageManager.lastStage()
    }
  }



  render() {
    return (

      <Configurer
        settingsInfo={{ showFooter: false, showTabBar: false, showHeader: false, headerTitle: '' }}
        title={"Login"}
        description={"Login"}
      >

        <section className="d-flex w-100 position-relative" style={{ minHeight: '100vh', padding: '0px', backgroundColor: '#282a42', backgroundRepeat: 'no-repeat', backgroundImage: "url(" + '/images/kheiry/fx-1.jpg' + ")", backgroundPosition: 'right', backgroundSize: 'cover' }}>
          <section className="row w-100 m-0 ">

            <section className="col-12 flexcc" style={{ opacity: this.state.mainOpacity, transition: 'all 0.5s', flex: '1 1 auto' }}>
              <div className="signin-bg">
                <StagesManager ref={el => this.stageManager = el} fast={true} >
                  <LoginFirstStep initData={this.state.data} setData={this.setData} settings={this.state.settings} postUserIndicator={this.state.settings.mode == "forgotPassword" ? this.postForgotPassword : this.postUserIndicator} stage={0} stageName={'init'} info={this.state.loginInfo} type={'phone'} />
                </StagesManager>
              </div>
            </section>
          </section>
        </section>

      </Configurer>

    )
  }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginWithUsername);
